import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Item, Stack, Box } from '@mui/material';
import parse from 'html-react-parser'
import { convertToHTML } from 'draft-convert';
import { convertFromRaw } from 'draft-js';

const Post = ({_id, title, content, createdAt}) => {

    const shareUrl = window.location.origin + '/' + _id;

    return  <Stack >
                <Box item xs={8}>
                    <Link to={`/read/${_id}`} style={{textDecoration: 'none', color: 'black', fontSize: '2rem'}}><h2>{title}</h2></Link>
                </Box>
                <Grid container spacing={2} style={{width: "100%", fontFamily: 'Georgia'}} >
                        <Grid item xs={12} >
                           {parse(content)}
                        </Grid>
                        <Grid item xs={5} sm={3}  md={2} sx={{ }}
                                        style={{alignItems: 'center'}}>
                                <span>{createdAt}</span>
                        </Grid>
                        <Grid item xs={5} sm={3} md={3}>
                                <span>Posted by Eren.</span>
                        </Grid>
                </Grid>
            </Stack>;
};

export default Post;
